import { useQuery } from "react-query";
import axios from '../axios';

const useGetLocations = () => {
  const query = useQuery(
    "locations",
    async () => {
      try {
        return await axios.get("/api/locations"); 
      } catch (error) {
        console.log(error);
      }
    },
    {
      staleTime: 30000
    }
  )

  return query;
}

export default useGetLocations;